define([
    'common/ui/view/svg/index'
], function(
    SVGView
    ) {
    /**
     * @exports views/diagram/label-text-view
     */
    var LabelTextView = SVGView.extend(
        /**
         * @lends module:views/diagram/label-text-view.LabelLabelTextView.prototype
         */
        {
            className: 'label',

            /**
             * ラベルとして使える、背景をを塗りつぶしたテキストです。
             *
             * 実際には g タグが返ってくるので動かしたい場合は
             * transform を使って下さい。
             *
             * @constructs
             * @param params
             * @param params.offset {Object}
             * @param params.offset.x {Number} - x 方向のオフセット
             * @param params.offset.y {Number} - y 方向のオフセット
             * @param params.size {Number} - Text のサイズ
             * @param params.text {Strgin} - Text の文字列
             */
            initialize: function(params) {
                LabelTextView.__super__.initialize.call(this, params);
                this.params = params;
                this._offset = params.offset;
                this._size = params.size;
                this._text = params.text;
            },

            render: function() {
                this.$bg = this.$el.append('text')
                    .classed('label-bg', true)
                    .style('font-size', this._size + 'px')
                    .attr('x', this._offset.x)
                    .attr('y', this._offset.y)
                    .attr('stroke-width', `${this._size/3}px`)
                    .text(this._text);

                this.$text = this.$el.append('text')
                    .classed('label-text', true)
                    .style('font-size', this._size + 'px')
                    .attr('x', this._offset.x)
                    .attr('y', this._offset.y)
                    .text(this._text);

                this.updateAttrs(this.params.attr);
                this.updateStyles(this.params.style);
                return this;
            },

            text: function(text) {
                this.$bg.text(text);
                this.$text.text(text);
            }
        }
    );

    return LabelTextView;
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/text/label.js